import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/cuentanostucaso")({
  beforeLoad: () => {
    throw redirect({ to: "/casos-reales", statusCode: 301 });
  },
});
